import {flow} from 'lodash';

/*
 * Preprocessing.
 */

export const preProcessPastedHtml: (html: string) => string = flow([maybeFixSabreAssets]);

/**
 * Workaround for HTML copied from Sabre, an app used by travel agency clients.
 *
 * Altour (ITV) https://hq.frontapp.com/companies/26373 uses an app called Sabre that generates HTML
 * snippets with embedded "file://" images, which miraculously works in Outlook. To make this work
 * in Front, we are hosting these images in ext.frontapp.com.
 */
function maybeFixSabreAssets(dirtyHtml: string): string {
  if (dirtyHtml.indexOf('Sabre Red Workspace') === -1) {
    return dirtyHtml;
  }

  return dirtyHtml.replace(
    /(<img[^>]+)src="file:\/[^"]+\/Sabre Red Workspace\/Profiles\/\w+\/configuration\/org\.eclipse\.osgi\/bundles\/\d+\/\d+\/\.cp\/images\/([^"]+)"/gi,
    '$1src="https://ext.frontapp.com/altour/Sabre+Red+Workspace/Profiles/S11F_1228/configuration/org.eclipse.osgi/bundles/732/1/.cp/images/$2"',
  );
}
